import PropTypes from 'prop-types'

import { AdasPaper } from '@components/wrapper-components'

// CAR-4067: pinned to the bottom of the page scroll area so Save / Set Up Complete stay in reach
// on the Pre-Calibration, Calibration and Post-Calibration pages. `square` (not `rounded-none`)
// drops `rounded-card`; z-20 stays below every pop-up and menu.
export const StickyFooter = ({ children, className = '' }) => {
  return (
    <AdasPaper className={`sticky bottom-0 z-20 w-[inherit] border-t border-muted bg-white py-3 ${className}`} elevation={0} square>
      {children}
    </AdasPaper>
  )
}

StickyFooter.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
}
